import { Component, OnInit } from '@angular/core';
import { WizardOption } from 'src/app/models/wizard/wizard-option';
import { ConfigService } from 'src/app/services/config/config.service';
import { WizardStepName } from 'src/app/services/wizard/wizard-step-name.enum';
import { WizardService } from 'src/app/services/wizard/wizard.service';

@Component({
  selector: 'app-ideal-use-case',
  templateUrl: './ideal-use-case.component.html',
  styleUrls: ['./ideal-use-case.component.scss']
})
export class IdealUseCaseComponent implements OnInit {
  useCaseOption: WizardOption = new WizardOption();
  title: string = "";

  constructor(private wizardService: WizardService, private confSvc: ConfigService) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();

    this.title = this.confSvc.getString("idealUseCaseTitle");

    this.wizardService.getSelectedWizardOptionsForStepAndWatch(WizardStepName.UseCase)
      .subscribe(options => {
        if(options.length) {
          this.useCaseOption = options[0];
        }
      });
  }
}
